import { IApplicationState } from '../../types/redux';

export const defaultState: IApplicationState['experiments'] = [];

export function experimentsReducer(
  state: IApplicationState['experiments'] = defaultState,
): IApplicationState['experiments'] {
  return state;
}
